<template>
    <template v-for="item in typeArr">
        <YearDetail :years="state.years" :data="state.data" :headerData="item"></YearDetail>
    </template>
</template>

<script lang="ts" config>
    import { reactive, watch, onMounted, types, CommonUtils, YearDetail } from "@/BaseComponent";

    export default {
        props: {
            data: { type: Array<types.statistics.StatisticsYearVOForApi>, default: {} },
            startYear: { type: Number, default: 0 },
            endYear: { type: Number, default: 0 },
        },
        components: { YearDetail },
        setup(props: any) {
            const state = reactive({
                data: [] as Array<types.statistics.StatisticsYearVOForApi>,
                startYear: 0 as number,
                endYear: 0 as number,
                years: [] as Array<number>,
            });

            const typeArr = [
                {
                    title: "실인원",
                    types: ["연도", "신규 내담자", "실인원", "1인당 평균 상담건수"],
                    keys: [998, 999],
                },
                {
                    title: "상담유형",
                    types: ["연도", "전화상담", "내방상담", "방문상담", "사이버", "서신", "아웃리치", "온라인상담", "합계"],
                    keys: [1, 2, 3, 5, 95, 6, 620],
                },

                {
                    title: "상담대상자",
                    types: [
                        "연도",
                        "본인",
                        "가족/친인",
                        "동료/이웃",
                        "타기관",
                        "성매매방지기관",
                        "유관기관",
                        "학교",
                        "검찰/경찰/법원",
                        "기타",
                        "합계",
                    ],
                    keys: [122, 123, 124, 125, 540, 541, 542, 543, 126],
                },

                {
                    title: "상담내용",
                    types: [
                        "연도",
                        "탈성매매",
                        "빚문제",
                        "폭행",
                        "진로(취업 등)",
                        "사회적낙인",
                        "건강의료문제",
                        "경찰조사",
                        "법률문제",
                        "가족문제",
                        "주거",
                        "자활문제",
                        "정서문제",
                        "사각지대PG",
                        "기타",
                        "합계",
                    ],
                    keys: [36, 37, 38, 400, 47, 570, 401, 402, 403, 43, 563, 725, 726, 50],
                },

                {
                    title: "상담조치결과",
                    types: ["연도", "정서적지원", "법률지원", "의료지원", "자활지원", "집단프로그램", "물적자원", "심리지원", "관련기관연계", "합계"],
                    keys: [51, 55, 54, 103, 404, 405, 406, 52],
                },

                {
                    title: "나이",
                    types: ["연도", "13세이하", "14~16세", "17~19세", "20~29세", "30~39세", "40~49세", "50~59세", "60세이상", "기록없음", "합계"],
                    keys: [205, 206, 207, 208, 209, 210, 211, 548, 212],
                },

                {
                    title: "만나이",
                    types: [
                        "연도",
                        "13세이하<br>(만 12세 이하)",
                        "14~16세<br>(만 13~15세)",
                        "17~19세<br>(만 16~18세)",
                        "20~29세<br>(만 19~28세)",
                        "30~39세<br>(만 29~38세)",
                        "40~49세<br>(만 39~38세)",
                        "50~59세<br>(만 49~58세)",
                        "60세이상<br>(만 59세 이상)",
                        "기록없음",
                        "합계",
                    ],
                    keys: [790, 791, 792, 793, 794, 795, 796, 797, 798],
                },

                {
                    title: "학력",
                    types: [
                        "연도",
                        "초재",
                        "초교중퇴",
                        "초교졸",
                        "중재",
                        "중교중퇴",
                        "중교졸",
                        "고재",
                        "고교중퇴",
                        "고교졸",
                        "대중퇴",
                        "대재",
                        "대졸",
                        "대학원재",
                        "대학원졸",
                        "기타",
                        "기록없음",
                        "합계",
                    ],
                    keys: [592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602, 603, 604, 605, 606, 607],
                },

                {
                    title: "상담경로",
                    types: [
                        "연도",
                        "1366,1388등",
                        "117",
                        "홍보(인터넷,114,언론보도등",
                        "지인소개",
                        "유관기관",
                        "성매매방지기관",
                        "학교",
                        "검찰/경찰/법원",
                        "기타",
                        "기록없음",
                        "합계",
                    ],
                    keys: [609, 610, 611, 612, 613, 614, 615, 616, 617, 618],
                },

                {
                    title: "성매매유형",
                    types: [
                        "연도",
                        "(전업형)<br>집결지",
                        "(전업형)<br>오피스텔",
                        "겸업형<br>(기존산업형)",
                        "위장형<br>(기존산업형)",
                        "출장형",
                        "온라인",
                        "해외성매매",
                        "기타",
                        "기록<br>없음",
                        "합계",
                    ],
                    keys: [220, 621, 622, 623, 624, 625, 562, 300, 301],
                },

                {
                    title: "알선고리",
                    types: [
                        "연도",
                        "보도방",
                        "소개업자",
                        "사채업자",
                        "업주",
                        "업소관계자",
                        "친구,지인",
                        "보호자,가족",
                        "홍보물",
                        "구인구직사이트",
                        "채팅앱",
                        "기타",
                        "기록없음",
                        "합계",
                    ],
                    keys: [771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782],
                },
            ];

            onMounted(() => {
                state.data = props.data;
                state.startYear = props.startYear;
                state.endYear = props.endYear;

                state.years = Array.from({ length: state.endYear - state.startYear + 1 }, (_, i) => state.startYear + i);
            });

            watch(props, () => {
                state.data = props.data;
                state.startYear = props.startYear;
                state.endYear = props.endYear;

                state.years = Array.from({ length: state.endYear - state.startYear + 1 }, (_, i) => state.startYear + i);
            });

            return {
                state,
                CommonUtils,

                typeArr,
            };
        },
    };
</script>
<style scoped>
    .areaGrid td {
        text-align: center;
    }
</style>
